// extracted by mini-css-extract-plugin
export default {"root":"picture_root__HqyZ9","placeHolderShimmer":"picture_placeHolderShimmer__zdhit"};